import React from 'react';

import { BuiltInComponents } from 'craft/constants';
import { ActionsToolbox } from 'craft/containers/Actions';
import { EmptyPlaceholder } from 'craft/containers/Toolbox/EmptyPlaceholder';
import { useMultiNodes } from 'craft/hooks';
import { FormSubmitAction } from 'craft/resolvers/Forms/toolbox/FormSubmitAction';
import { useComponentSchema, useFlowAncestor, useFormAncestor } from 'craft/state';

import { InteractionAnalytics } from './InteractionAnalytics/InteractionAnalytics';

interface Props {
  nodeIds: string[];
}

export const Interactions = ({ nodeIds }: Props) => {
  const { type, props } = useMultiNodes(nodeIds, (node) => ({ props: node?.data?.props }));
  const componentSchema = useComponentSchema(type);
  const { isInFlow } = useFlowAncestor(nodeIds[0]);
  const { isInForm, isMultistepForm, formNodeId } = useFormAncestor(nodeIds[0]);
  if (
    !isMultistepForm &&
    type !== BuiltInComponents.FormSingleSelectCard &&
    (!componentSchema?.actions ||
      (type === BuiltInComponents.Modal && props?.isDismissible !== true) ||
      (type === BuiltInComponents.RichTextEditor && props?.hasCopy !== true))
  ) {
    // TODO: remove once APP-2086 is done, this is a temporary fix
    if (
      isInFlow &&
      formNodeId &&
      isInForm &&
      (type === BuiltInComponents.Form || type === BuiltInComponents.FormSubmitButton)
    ) {
      return <FormSubmitAction nodeIds={nodeIds} />;
    }

    return (
      <>
        <EmptyPlaceholder
          title="Static Component"
          subtitle="The Component you selected is not interactive"
        />
        <InteractionAnalytics nodeId={nodeIds[0]} />
      </>
    );
  }

  return (
    <>
      <ActionsToolbox nodeIds={nodeIds} />
      <InteractionAnalytics nodeId={nodeIds[0]} />
    </>
  );
};
